export const val = {
  firmName: 'Shailesh R & Co.'
};
